/** Sibling views within a Desk module — plan/35 Desk module tabs. */

export type DeskModuleTab = {
  id: string;
  label: string;
  to: string;
};

function pathEqualsOrChild(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

/** True when `pathname` belongs to this tab (not a sibling with a longer prefix). */
export function deskModuleTabActive(
  pathname: string,
  tab: DeskModuleTab,
  siblings: readonly DeskModuleTab[],
): boolean {
  if (!pathEqualsOrChild(pathname, tab.to)) return false;
  // Prefer the longest matching sibling prefix (e.g. /pos/tickets over /pos).
  const longerSiblingOwns = siblings.some(
    (other) =>
      other.id !== tab.id &&
      other.to.length > tab.to.length &&
      pathEqualsOrChild(pathname, other.to),
  );
  return !longerSiblingOwns;
}

/** Object tabs only — queues live on Home / ⌘K / routes (plan/35). */
export function salesModuleTabs(companySlug: string): DeskModuleTab[] {
  const root = `/c/${companySlug}/sales`;
  return [
    { id: "orders", label: "Orders", to: `${root}/orders` },
    { id: "invoices", label: "Invoices", to: `${root}/invoices` },
    { id: "in-transit", label: "In transit", to: `${root}/in-transit` },
    { id: "payments", label: "Payments", to: `${root}/payments` },
  ];
}

/** Object tabs only — queues live on Home / ⌘K / routes (plan/35). */
export function purchasingModuleTabs(companySlug: string): DeskModuleTab[] {
  const root = `/c/${companySlug}/purchasing`;
  return [
    { id: "orders", label: "Orders", to: `${root}/orders` },
    { id: "invoices", label: "Invoices", to: `${root}/invoices` },
    { id: "in-transit", label: "In transit", to: `${root}/in-transit` },
    { id: "payments", label: "Payments", to: `${root}/payments` },
  ];
}

/** POS Desk lists (not the register Floor). */
export function posModuleTabs(companySlug: string): DeskModuleTab[] {
  const root = `/c/${companySlug}/pos`;
  return [
    { id: "sales", label: "Sales", to: `${root}/tickets` },
    { id: "terminals", label: "Terminals", to: root },
  ];
}

/** Products + on-hand + convert — one stock family. */
export function stockModuleTabs(companySlug: string): DeskModuleTab[] {
  const root = `/c/${companySlug}`;
  return [
    { id: "products", label: "Products", to: `${root}/products` },
    { id: "on-hand", label: "On hand", to: `${root}/inventory` },
    { id: "convert", label: "Convert", to: `${root}/inventory/convert` },
  ];
}
